import { ImageLoaderProps } from 'next/image';

export const absolutePathImageLoader = ({ src, width, quality }: ImageLoaderProps) =>
  `${src}?w=${width}&q=${quality || 75}`;
